// @flow
import React, { useContext } from 'react';
import bem from '@justpark/helpers/src/bem/bem';
import { useDispatch } from 'react-redux';
import { toggleFilterPanel } from '../../../stores/search';
import { getQueryParam } from '../../../helpers/utils';
import BrowserContext from '../../../context/BrowserContext';
import FilterIcon from '../../../svg/search_filter.svg';

import '../../../../static/scss/components/searchFilters/searchResultsFilterButton.scss';

const className = 'c-search-results-filter-button';

type Props = {
  searchQuery: string
};

const SearchResultsFilterButton = ({ searchQuery }: Props) => {
  const dispatch = useDispatch();
  const togglePanel = () => dispatch(toggleFilterPanel());
  const browser = useContext(BrowserContext);
  const isNotSmall = browser.greaterThan.extraSmall;

  const filterString = getQueryParam(searchQuery, 'filters');
  const { length: filterLength } = filterString ? filterString.split(',') : [];
  const lengthFormatted = filterLength > 9 ? `9+` : filterLength;

  return (
    <button className={className} type="button" onClick={togglePanel}>
      <FilterIcon />
      {filterLength > 0 && (
        <div className={bem(className, 'counter')}>
          <span>{lengthFormatted}</span>
        </div>
      )}
      {isNotSmall && <p className={bem(className, 'description')}>Filters</p>}
    </button>
  );
};

export default SearchResultsFilterButton;
